module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_11.7e8cfe95.svg";